import s from "i18next";
import { initReactI18next as a } from "react-i18next";
import e from "./default-labels.js";
const n = "translation", t = s.createInstance();
t.use(a);
const o = {
  lng: "sv",
  supportedLngs: ["sv", "en", "de"],
  fallbackLng: "sv",
  debug: !1,
  interpolation: {
    escapeValue: !1
    // not needed for react as it escapes by default
  },
  resources: {
    sv: {
      [n]: e.sv
    },
    en: {
      [n]: e.en
    },
    de: {
      [n]: e.de
    },
    nn: {}
  }
};
t.init(o);
export {
  t as default,
  n as defaultNamespace
};
